<div class="flex flex-col justify-center">
  <div class="flex items-center justify-center">
    <h4>{{title}}</h4>
  </div>
  <div class="flex items-center justify-center tracker-value">
    <p>{{value}}</p>
  </div>
</div>